<template>
  <div>
    <loginHeader />

    <div class="login">
      <div class="w1300">
        <div class="wrapper">
          <div class="title txt-c tit-32 fw700">注册优理奇账号</div>

          <el-tabs
            v-model="activeName"
            @tab-click="handleClick"
            class="tabs"
            ref="parentRef"
          >
            <el-tab-pane label="个人用户" name="first" class="firstTab">
              <div class="item">
                <el-input
                  placeholder="请输入手机号"
                  v-model="userInfo.phone"
                  @blur="validatePhone"
                  :class="{ 'is-error': errors.phone }"
                ></el-input>
                <div class="erro" v-if="errors.phone">
                  <span class="tit-12">{{ errors.phone }}</span>
                </div>
              </div>

              <div class="item">
                <drag-verify
                  v-model="userInfo.verify"
                  ref="dragVerify"
                  :width="dragWidth"
                  :height="dragHeight"
                  :isPassing.sync="isPassing"
                  text="请按住滑块拖动"
                  successText="验证通过"
                  handlerIcon="el-icon-d-arrow-right"
                  successIcon="el-icon-circle-check"
                  @passcallback="passcallback"
                >
                  <i
                    v-show="!isPassing"
                    slot="textBefore"
                    class="el-icon-lock"
                  ></i>
                </drag-verify>

                <div class="erro" v-if="errors.verify">
                  <span class="tit-12">{{ errors.verify }}</span>
                </div>
              </div>
              <div class="item">
                <el-input
                  placeholder="请输入邮箱"
                  class="mr-10"
                  @blur="validateemail"
                  v-model="userInfo.email"
                  :class="{ 'is-error': errors.email }"
                ></el-input>
                <div class="erro" v-if="errors.email">
                  <span class="tit-12">{{ errors.email }}</span>
                </div>
              </div>
              <div class="item getCode">
                <el-input
                  placeholder="请输入验证码"
                  class="mr-10"
                  v-model="userInfo.code"
                  maxlength="6"
                  @blur="validateCode"
                  :class="{ 'is-error': errors.code }"
                ></el-input>
                <el-button
                  @click="sendCode"
                  :disabled="!canSend || countdown > 0"
                >
                  {{ countdown > 0 ? `${countdown}s后重新获取` : "获取验证码" }}
                </el-button>

                <div class="erro" v-if="errors.code">
                  <span class="tit-12">{{ errors.code }}</span>
                </div>
              </div>

              <div class="item">
                <el-input
                  placeholder="设置密码"
                  v-model="userInfo.password"
                  @blur="validatePassword"
                  show-password
                  :class="{ 'is-error': errors.password }"
                ></el-input>
                <div class="erro" v-if="errors.password">
                  <span class="tit-12">{{ errors.password }}</span>
                </div>
              </div>

              <div class="item">
                <el-input
                  placeholder="确认密码"
                  v-model="userInfo.password2"
                  @blur="validatePassword2"
                  show-password
                  :class="{ 'is-error': errors.password2 }"
                ></el-input>
                <div class="erro" v-if="errors.password2">
                  <span class="tit-12">{{ errors.password2 }}</span>
                </div>
              </div>

              <div class="item sub">
                <el-button
                  type="primary"
                  class="btn"
                  @click="submitForm"
                  :loading="loading"
                >
                  注册
                </el-button>
              </div>

              <div class="item tit-14 txt-c">
                <span>已有账号？</span>
                <router-link to="/login" class="forget cor-0030F5">
                  立即登录
                </router-link>
              </div>
            </el-tab-pane>
            <el-tab-pane label="企业用户" name="second" class="secondTab">
              <div class="item">
                <el-input
                  placeholder="请输入企业名称"
                  v-model="userInfo.company"
                  @blur="validateCompany"
                  :class="{ 'is-error': errors.company }"
                ></el-input>
                <div class="erro" v-if="errors.company">
                  <span class="tit-12">{{ errors.company }}</span>
                </div>
              </div>

              <div class="item">
                <el-input
                  placeholder="请输入手机号"
                  v-model="userInfo.phone"
                  @blur="validatePhone"
                  :class="{ 'is-error': errors.phone }"
                ></el-input>
                <div class="erro" v-if="errors.phone">
                  <span class="tit-12">{{ errors.phone }}</span>
                </div>
              </div>

              <div class="item">
                <drag-verify
                  v-model="userInfo.verify"
                  ref="dragVerify"
                  :width="dragWidth"
                  :height="dragHeight"
                  :isPassing.sync="isPassing"
                  text="请按住滑块拖动"
                  successText="验证通过"
                  handlerIcon="el-icon-d-arrow-right"
                  successIcon="el-icon-circle-check"
                  @passcallback="passcallback"
                >
                  <i
                    v-show="!isPassing"
                    slot="textBefore"
                    class="el-icon-lock"
                  ></i>
                </drag-verify>

                <div class="erro" v-if="errors.verify">
                  <span class="tit-12">{{ errors.verify }}</span>
                </div>
              </div>
              <div class="item">
                <el-input
                  placeholder="请输入邮箱"
                  class="mr-10"
                  @blur="validateemail"
                  v-model="userInfo.email"
                  :class="{ 'is-error': errors.email }"
                ></el-input>
                <div class="erro" v-if="errors.email">
                  <span class="tit-12">{{ errors.email }}</span>
                </div>
              </div>
              <div class="item getCode">
                <el-input
                  placeholder="请输入验证码"
                  class="mr-10"
                  v-model="userInfo.code"
                  maxlength="6"
                  @blur="validateCode"
                  :class="{ 'is-error': errors.code }"
                ></el-input>
                <el-button
                  @click="sendCode"
                  :disabled="!canSend || countdown > 0"
                >
                  {{ countdown > 0 ? `${countdown}s后重新获取` : "获取验证码" }}
                </el-button>

                <div class="erro" v-if="errors.code">
                  <span class="tit-12">{{ errors.code }}</span>
                </div>
              </div>

              <div class="item">
                <el-input
                  placeholder="设置密码"
                  v-model="userInfo.password"
                  @blur="validatePassword"
                  show-password
                  :class="{ 'is-error': errors.password }"
                ></el-input>
                <div class="erro" v-if="errors.password">
                  <span class="tit-12">{{ errors.password }}</span>
                </div>
              </div>

              <div class="item">
                <el-input
                  placeholder="确认密码"
                  v-model="userInfo.password2"
                  @blur="validatePassword2"
                  show-password
                  :class="{ 'is-error': errors.password2 }"
                ></el-input>
                <div class="erro" v-if="errors.password2">
                  <span class="tit-12">{{ errors.password2 }}</span>
                </div>
              </div>

              <div class="item sub">
                <el-button
                  type="primary"
                  class="btn"
                  @click="companySubmit"
                  :loading="loading"
                >
                  注册
                </el-button>
              </div>

              <div class="item tit-14 txt-c">
                <span>已有账号？</span>
                <router-link to="/login" class="forget cor-0030F5">
                  立即登录
                </router-link>
              </div>
            </el-tab-pane>
          </el-tabs>

          <div class="copyRight txt-c tit-14">
            <div>
              <span @click="showDialog(1)" class="cur">隐私政策 · </span>
              <span @click="showDialog(2)" class="cur">用户协议</span>
              <!-- <span>苏ICP备1234567890号 </span> -->
            </div>
            <!-- <div>Copyright @ 2025 优理奇机器人(苏州)有限公司版权所有</div> -->
            <div>{{ shu.synopsis.hezuopeizhi.beianhao }}</div>
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      title=""
      :visible.sync="dialogVisible"
      width="50%"
      top="0"
      :before-close="handleClose"
    >
      <div class="info tit-333" v-html="dialogContent.neirong"></div>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">
          确 定
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
let that;
import loginHeader from "@/components/loginHeader.vue";
// import { getCode, login } from "@/api/login";

import dragVerify from "vue-drag-verify2";

export default {
  name: "registerIndex",

  components: {
    loginHeader,
    dragVerify,
  },

  data() {
    return {
      activeName: "first",
      dragWidth: 465, // 默认宽度（PC端）
      dragHeight: 50, // 默认高度
      isPassing: false,
      loading: false,
      canSend: false, // 是否可以发送验证码
      countdown: 0, // 倒计时
      timer: null, // 定时器
      userInfo: {
        company: "",
        phone: "",
        verify: "",
        code: "",
        password: "",
        password2: "",
        email: "",
      },

      errors: {
        company: "",
        phone: "",
        verify: "",
        code: "",
        password: "",
        password2: "",
        email: "",
      },
      shu: { synopsis: { hezuopeizhi: {} } },
      // 弹窗
      dialogVisible: false,
      // 弹窗内容
      dialogContent: "", // 用于存储当前要显示的内容类型
    };
  },
  created() {
    that = this;
    that.$post("k=company", function(s) {
      that.shu = s.shu;
    });
  },
  watch: {
    // "userInfo.phone": function () {
    //   this.checkCanSend();
    // },
    "userInfo.email": function() {
      this.checkCanSend();
    },
    isPassing: function() {
      this.checkCanSend();
    },
  },

  methods: {
    handleClick(tab, event) {
      // 切换标签页时重置表单
      this.isPassing = false;
      this.resetForm();
      if (this.$refs.dragVerify) {
        this.$refs.dragVerify.reset();
      }
    },

    // 验证手机号
    validatePhone() {
      if (!this.userInfo.phone) {
        this.errors.phone = "请输入手机号码";
        return false;
      }
      if (!/^1[3-9]\d{9}$/.test(this.userInfo.phone)) {
        this.errors.phone = "请输入正确的手机号码";
        return false;
      }
      this.errors.phone = "";
      return true;
    },
    // 验证邮箱
    validateemail() {
      if (!this.userInfo.email) {
        this.errors.email = "请输入邮箱";
        return false;
      }

      const emailReg = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (!emailReg.test(this.userInfo.email)) {
        this.errors.email = "请输入正确的邮箱格式";
        return false;
      }

      this.errors.email = "";
      return true;
    },
    // 验证企业名称
    validateCompany() {
      if (!this.userInfo.company) {
        this.errors.company = "请输入企业名称";
        return false;
      }
      this.errors.company = "";
      return true;
    },

    // 验证验证码
    validateCode() {
      if (!this.userInfo.code) {
        this.errors.code = "请输入验证码";
        return false;
      }
      if (!/^\d{6}$/.test(this.userInfo.code)) {
        this.errors.code = "验证码为6位数字";
        return false;
      }
      this.errors.code = "";
      return true;
    },

    // 验证密码
    validatePassword() {
      if (!this.userInfo.password) {
        this.errors.password = "请输入密码";
        return false;
      }
      this.errors.password = "";
      return true;
    },

    // 验证确认密码
    validatePassword2() {
      if (!this.userInfo.password2) {
        this.errors.password2 = "请输入确认密码";
        return false;
      }
      if (this.userInfo.password !== this.userInfo.password2) {
        this.errors.password2 = "两次输入的密码不一致";
        return false;
      }
      this.errors.password2 = "";
      return true;
    },

    // 检查是否可以发送验证码
    checkCanSend() {
      console.log(this.validatePhone(), "this.validatePhone");
      console.log(this.validateemail(), "validateemail");
      console.log(this.isPassing, "isPassing");
      this.canSend =
        this.validatePhone() && this.isPassing && this.validateemail();
    },

    // 滑块验证通过回调
    passcallback() {
      this.errors.verify = "";
      this.checkCanSend(); // 添加这行
    },

    // 发送验证码
    sendCode() {
      if (!this.validatePhone()) return;
      if (!this.validateemail()) return;
      if (!this.isPassing) {
        this.errors.verify = "请完成滑块验证";
        return;
      }

      // 模拟发送验证码
      this.countdown = 60;
      this.timer = setInterval(() => {
        this.countdown--;
        if (this.countdown <= 0) {
          clearInterval(this.timer);
        }
      }, 1000);
      if (!this.userInfo.email || this.userInfo.email == "") {
        this.errors.email = "请输入邮箱";
        return false;
      }
      // this.$post('k=denglu&x=zhuce', { c: 'yanzhengma', shouji:this.userInfo.email}, (s)=>{
      this.$post(
        "k=denglu&x=zhuce",
        { c: "emailyzm", shouji: this.userInfo.email },
        (s) => {
          this.$xiaoxi(s.shu);
          if (s.shi == 1) {
            this.$message.success("验证码已发送 " + res.message);
          } else {
            clearInterval(stop);
          }
        },
      );
    },

    // 提交表单
    submitForm() {
      var that = this;
      if (!that.validatePhone()) return;
      if (!that.validateemail()) return;
      if (!that.isPassing) {
        that.errors.verify = "请完成滑块验证";
        return;
      }
      if (!that.validateCode()) return;
      if (!that.validatePassword()) return;
      if (!that.validatePassword2()) return;

      that.loading = true;

      // 模拟登录请求
      setTimeout(() => {
        that.loading = false;
        that.$post(
          "k=denglu&c=zhuce",
          {
            shouji: that.userInfo.phone,
            yanzheng: that.userInfo.code,
            activeName: that.activeName,
            mima: that.userInfo.password,
            email: that.userInfo.email,
          },
          function(s) {
            if (s.shi == 1) {
              that.$router.push("/login");
              // that.$quanju('$yonghux',s.shu);
              // that.$cun('yonghux', s.shu);
              // that.$store.commit('gaiyonghu',s.shu);
              // that.$dakai('/');
            } else {
              that.$message.error(s.shu);
            }
          },
        );
      }, 1000);
    },

    // 重置表单
    resetForm() {
      this.userInfo = {
        company: "",
        phone: "",
        verify: "",
        code: "",
        password: "",
        password2: "",
        email: "",
      };
      this.errors = {
        company: "",
        phone: "",
        verify: "",
        code: "",
        password: "",
        password2: "",
        email: "",
      };
      this.isPassing = false;
      clearInterval(this.timer);
      this.countdown = 0;
    },

    companySubmit() {
      var that = this;
      if (!that.validateCompany()) return;
      if (!that.validatePhone()) return;
      if (!that.validateemail()) return;
      if (!that.isPassing) {
        that.errors.verify = "请完成滑块验证";
        return;
      }
      if (!that.validateCode()) return;
      if (!that.validatePassword()) return;
      if (!that.validatePassword2()) return;

      that.loading = true;
      that.$post(
        "k=denglu&c=zhuce",
        {
          shouji: that.userInfo.phone,
          yanzheng: that.userInfo.code,
          company: that.userInfo.company,
          activeName: that.activeName,
          mima: that.userInfo.password,
          email: that.userInfo.email,
        },
        function(s) {
          if (s.shi == 1) {
            that.$quanju("$yonghux", s.shu);
            that.$cun("yonghux", s.shu);
            that.$store.commit("gaiyonghu", s.shu);
            that.$dakai("/");
          } else {
            that.$message.error(s.shu);
          }
          that.loading = false;
        },
      );
    },

    // 显示弹窗
    // showDialog(type) {
    //   this.dialogContent = type;
    //   this.dialogVisible = true;
    // },
    // 显示弹窗
    showDialog(type) {
      let apiParam = "";

      console.log(1);

      // 根据类型设置标题和接口参数
      if (type === 1) {
        this.dialogTitle = "用户协议";
        apiParam = "用户协议";
      } else if (type === 2) {
        this.dialogTitle = "隐私政策";
        apiParam = "隐私政策";
      }

      // 有接口参数时发起请求
      if (apiParam) {
        // 发起POST请求获取协议内容
        this.$post(
          "k=wenzhang&c=xiangqing",
          {
            id: apiParam,
            // ye: 1, // 页码（固定第一页）
            // jitiao: 20, // 条数（足够获取所有协议）
          },
          (response) => {
            // 请求成功且有有效内容
            if (response.shi === 1) {
              console.log(response);

              this.dialogContent = response.shu;
            } else {
              // 请求失败时显示提示文本
              this.dialogContent =
                type === 1
                  ? "获取用户服务协议内容失败"
                  : "获取隐私政策内容失败";
            }
          },
          (error) => {
            // 网络请求失败的容错处理
            console.error("协议内容请求失败：", error);
            this.dialogContent = "网络异常，获取协议内容失败，请稍后重试";
          },
        );
      }

      // 显示弹窗
      this.dialogVisible = true;
    },
    handleClose(done) {
      // 关闭对话框的处理逻辑
      done();
    },

    adjustDragSize() {
      // 获取屏幕宽度，判断是否为移动端
      const screenWidth = window.innerWidth;

      // 获取父元素的实际宽度（含padding/border，按需调整）
      const parentEl = this.$refs.parentRef;
      if (!parentEl) return;

      // console.log(parentEl.$el.clientWidth, "parentEl");

      if (screenWidth < 768) {
        // 父元素宽度（clientWidth：不含margin，含padding/border）
        this.dragWidth = parentEl.$el.clientWidth;
        this.dragHeight = 45; // 移动端高度（也可设为 screenWidth * 0.08 等比例值）
      } else {
        // PC端：恢复原固定值
        this.dragWidth = 465;
        this.dragHeight = 50;
      }
    },
  },
  mounted() {
    // 2. 监听屏幕尺寸变化，动态调整宽高
    this.adjustDragSize();
    window.addEventListener("resize", this.adjustDragSize);
  },

  // 组件销毁前清除定时器
  beforeDestroy() {
    clearInterval(this.timer);
    // 清理监听事件，避免内存泄漏
    window.removeEventListener("resize", this.adjustDragSize);
  },
};
</script>

<style lang="less" scoped>
.login .w1300 {
  min-height: calc(100vh - 70px);
  padding: 4vh 0;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;

  .wrapper {
    width: 100%;
  }
}

.tabs {
  width: 465px;
  // min-width: 300px;
  margin: 0 auto;
  margin-top: 40px;

  /deep/.el-tabs__nav {
    width: 100%;

    .el-tabs__active-bar {
      background: #333333;
    }

    .el-tabs__item {
      width: 50%;
      text-align: center;
      height: 45px;
      line-height: initial;
      color: #b4b4b4;
      letter-spacing: 1px;
      font-size: var(--font16);

      &.is-active {
        color: #333333;
        font-weight: 700;
      }
    }
  }

  // 短信登录

  .firstTab {
    .item {
      margin: 25px 0;
      position: relative;
      .label {
        margin-bottom: 0.1rem;
      }

      /deep/ .el-input__inner {
        background: #ededed;
        border-radius: 100px;
        height: 52px;
        padding: 0 35px;

        &::placeholder {
          color: #9a9a9a;
        }
      }
    }

    /deep/ .getCode {
      .el-input__inner {
        padding-right: 120px;
      }
      button {
        position: absolute;
        right: 0;
        height: 100%;
        top: 0;
        background: none;
        border: 0;
      }
    }

    .sub {
      width: 100%;
      /deep/ button {
        border: 0;
        padding: 18px 0;
        width: 100%;
        background: #000000;
        border-radius: 100px;
        font-size: var(--font16);
      }
    }
  }

  // 账号登录
  .secondTab {
    .item {
      margin: 25px 0;
      position: relative;
      .label {
        margin-bottom: 0.1rem;
      }

      /deep/ .el-input__inner {
        background: #ededed;
        border-radius: 100px;
        height: 52px;
        padding: 0 35px;

        &::placeholder {
          color: #9a9a9a;
        }
      }
    }

    /deep/ .getCode {
      .el-input__inner {
        padding-right: 120px;
      }
      button {
        position: absolute;
        right: 0;
        height: 100%;
        top: 0;
        background: none;
        border: 0;
      }
    }

    .forgetPass {
      padding-left: 35px;

      a {
        text-decoration-line: underline;
      }
    }

    .sub {
      width: 100%;
      /deep/ button {
        border: 0;
        padding: 18px 0;
        width: 100%;
        background: #000000;
        border-radius: 100px;
        font-size: var(--font16);
      }
    }
  }

  // 滑块验证
  /deep/ .drag_verify {
    border-radius: 100px !important;
    .dv_handler {
      border: 1px solid #ccc;
      border-radius: 50%;
    }
  }

  .erro {
    color: #f56c6c;
    font-size: 12px;
    line-height: 1;
    padding-top: 4px;
    position: absolute;
    top: 100%;
    left: 35px;
  }

  .is-error {
    /deep/ .el-input__inner {
      border-color: #f56c6c;
    }
  }
}

// 弹窗
/deep/ .el-dialog {
  top: 5vh;
  margin: 5vh auto;
  .el-dialog__body {
    max-height: 80vh;
    overflow-y: auto;
    .info {
      color: initial;

      h2 {
        margin: revert;
      }
      ol {
        margin: revert;
        padding: revert;
        li {
          margin: inherit;
          padding: revert;
          list-style: inherit;
        }
      }

      ul {
        margin: revert;
        padding: revert;
        li {
          margin: inherit;
          padding: revert;
          list-style: initial;
        }
      }
    }
  }
  .el-dialog__footer {
    text-align: center;

    .el-button--primary {
      border: 0;
      background: #000000;
    }
  }
}

@media screen and (max-width: 767px) {
  .tabs {
    width: 100%;

    /deep/ .el-tabs__nav .el-tabs__item {
      height: 36px;
    }

    /deep/ .firstTab .item {
      margin: 16px 0;

      .el-input__inner {
        height: 45px;
      }
    }

    /deep/ .secondTab .item {
      margin: 16px 0;

      .el-input__inner {
        height: 45px;
      }
    }
  }

  /deep/ .el-dialog {
    width: 90% !important;
  }
}
</style>
